module.exports = __webpack_public_path__ + "static/media/sunday.9288cb0b.png";